
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.667 4a4 4 0 014-4h20a4 4 0 014 4v20a4 4 0 01-4 4h-20a4 4 0 01-4-4V4z","fill":"#DBEAFE"}}),_c('path',{attrs:{"d":"M8.849 6.5h11.624a1.057 1.057 0 010 2.114H8.85a1.057 1.057 0 110-2.114zM13.076 9.012h2.642v1.521h-2.642v-1.52zM15.277 14.719a3.737 3.737 0 00-.484-1.761 3.736 3.736 0 00-.484 1.76c0 .974.215 1.762.484 1.762.27 0 .484-.789.484-1.761z","fill":"#1B77DF"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.121 21.5H9.201a1.411 1.411 0 01-1.41-1.41l1.234-7.749a1.41 1.41 0 011.408-1.41h8.279a1.41 1.41 0 011.41 1.41l1.408 7.75a1.41 1.41 0 01-1.409 1.409zm-5.372-9.159a3.963 3.963 0 100 7.927 3.963 3.963 0 000-7.927z","fill":"#1B77DF"}})])
          )
        }
      }
    